/**
 * DAAily Operations per-page access model — the same hub-gated pattern as
 * Analytics (see analyticsPages.ts, the reference implementation).
 *
 * Two roles on top of `tools.operations.enabled`:
 *  - ADMIN  (`tools.operations.role` ∈ {admin, approver_admin}, or app admin) —
 *    sees every page and grants page access (Operations → Admin).
 *  - VIEWER (enabled, not admin) — sees ONLY the pages granted in
 *    `user.operationsPages` (deny-by-default; nothing until granted). The whole
 *    company is pre-enabled for the tool, so a page GRANT is the access decision.
 *
 * CONVENTION: every provisionable sub-nav page has a stable `key` listed here.
 * When a new operations sub-nav is added, add its key to OPERATIONS_PAGES so it
 * participates in provisioning (registry entries carry the same key).
 */
/** The provisionable operations pages (NOT the admin area — that's admin-only). */
export const OPERATIONS_PAGES = [
    { key: 'overview', label: 'Overview' },
    { key: 'contentManager', label: 'Content Manager' },
    { key: 'auditManufacturers', label: 'Manufacturer audit' },
    { key: 'marginProducts', label: 'Margin of Products' },
    { key: 'paypalDesignboom', label: 'designboom PayPal' },
    { key: 'googleNewsFeed', label: 'News feed' },
    { key: 'accounting', label: 'Accounting' },
    // PSM Operations (Oct 2026): the Homepage banner, HIU and Medium Rectangle generators as tabs. Replaces the
    // earlier `homepageBanner` key (grants migrated; the server still accepts the old key).
    { key: 'psmOperations', label: 'PSM Operations' },
];
export const OPERATIONS_PAGE_KEYS = OPERATIONS_PAGES.map((p) => p.key);
/** Operations admin = app admin OR an admin-flavored tool role. */
export function isOperationsAdmin(opts) {
    return opts.isAppAdmin || opts.role === 'admin' || opts.role === 'approver_admin';
}
/** Can this user see a given page? Admins → all; viewers → granted only. */
export function canViewOperationsPage(admin, granted, key) {
    if (admin)
        return true;
    return (granted ?? []).includes(key);
}
/** The page keys this user can see (admins = all). */
export function visibleOperationsPages(admin, granted) {
    return admin ? OPERATIONS_PAGE_KEYS : (granted ?? []).filter((k) => OPERATIONS_PAGE_KEYS.includes(k));
}
//# sourceMappingURL=operationsPages.js.map